import StripeProduct from '@/datatypes/stripe/product';

export default class StripeSubscriptionUsage {
  public id: string;
  public totalUsage: number;
  public product: StripeProduct;

  constructor(options) {
    this.id = options.id;
    this.totalUsage = options.totalUsage;
    if (options.product) {
      this.product = new StripeProduct(options.product);
    } else {
      this.product = new StripeProduct({});
    }
  }
}
